import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from "@angular/material/icon";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MeStore } from '../auth.me.store';
import { LoginComponent } from "../login/login";

@Component({
  imports: [MatButtonModule, FormsModule, LoginComponent, MatIcon],
  selector: 'app-authorize',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
@if (this.meStore.isAuthenticated() === true) {
<br>Authorize your Agent to access your TODOs: 
<button matButton="filled" (click)="authorize()" [disabled]="!this.meStore.zumo()">Authorize</button>
} @else if (this.meStore.isAuthenticated() === false) {
<p>You need to sign in to authorize your Agent</p>
<p style="display: flex; align-items: center;">If you use different browser - you can copy
<button type="button" matRipple mat-icon-button="elevated" (click)="copyUrl()" [disabled]="meStore.isLoading()">
      <mat-icon>content_copy</mat-icon>
</button>
  the url & paste it in the right browser</p>
}

@if (!this.meStore.zumo()) {
<app-login [autoLogin]="true" [post_login_redirect_uri]="GetRedirectUrl()">
</app-login>
}

 `
})
export class AuthorizeComponent {
  meStore = inject(MeStore);
  router = inject(Router);
  snackBar = inject(MatSnackBar);
  zumo = signal<string | null>(null);

  GetRedirectUrl() {
    const queryParams = this.router.routerState.root.snapshot.queryParams;
    const queryString = new URLSearchParams({ ...queryParams }).toString();
    return `authorize?${queryString}`;
  }  
  copyUrl(): void {
    navigator.clipboard.writeText(window.location.href)
      .then(() => this.snackBar.open('Authorization URL copied to clipboard!', 'Close', { duration: 2000 }))
      .catch(err => this.snackBar.open('Failed to copy: ' + err, 'Close', { duration: 2000 }));
  }
  authorize(): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/todos-auth/authorize';
    form.target = '_blank';
    const queryParams = this.router.routerState.root.snapshot.queryParams;

    for (const [key, value] of Object.entries({ ...queryParams, token: this.meStore.zumo()! })) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }
}
